<template>
  <print ref="print"></print>
</template>
<script>
import print from "@/components/common/customprint/index";
export default {
  components: { print },
  data() {
    return {
      api: require("@/api/sa/saDoc").default,
      data: {}
    }
  },
  mounted() {
    var josn_str = sessionStorage.getItem("salecount_print");
    if (josn_str) this.data = JSON.parse(josn_str);
    // console.log('params', this.data);
    this.api.orderList(this.data.Params).then(res => {
      if (res.Code == 0) {
        var data = {
          Title: "销货单统计表", TableNames: this.data.TableNames, Params: this.data.Params,
          ParamsData: this.data.ParamsData, List: res.Data
        };
        this.$refs.print.setData(data);
      }
    })
  },
}
</script>